export default __webpack_public_path__ + "static/media/recorded-lessons.a4d96b6c.jpg";